import { FileIcon } from '~components/icons'
import { COLORS } from '~theme/colors'
import ExcelIcon from './excel-icon'
import PdfIcon from './pdf-icon'
import WordIcon from './word-icon'

export const getFileIcon = (fileType: string) => {
  switch (fileType.toLowerCase()) {
    case 'pdf':
      return <PdfIcon width="17px" height="22px" />
    case 'xls':
    case 'xlsx':
    case 'xlsb':
    case 'xlsm':
      return <ExcelIcon width="17px" height="22px" />
    case 'doc':
    case 'docx':
      return <WordIcon width="17px" height="22px" />
    default:
      return (
        <FileIcon
          color={COLORS.primary.maerskBlue}
          width="24px"
          height="40px"
        />
      )
  }
}
